<template>
  <v-card class="cp-form-card">
    <v-card-title
      class="pb-4"
      primary-title
    >
      <div>Informacje podstawowe</div>
    </v-card-title>

    <v-card-text class="pb-0">
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Nazwa projektu *</label>
          <v-text-field
            :value="value.name"
            v-bind="props.validatedField"
            :rules="[rules.required]"
            :disabled="disabled"
            placeholder="Podaj nazwę"
            @input="update('name', $event)"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Typ projektu *</label>
          <v-select
            :value="value.commercialPrintType"
            :items="filtersOptions.commercialPrintTypes"
            item-text="name"
            item-value="id"
            :rules="[rules.required]"
            placeholder="Wybierz typ"
            v-bind="props.select"
            :hide-details="false"
            height="40"
            :disabled="disabled"
            @input="update('commercialPrintType', $event)"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Termin wykonania *</label>
          <v-menu
            ref="datePicker"
            v-model="isDatePickerShown"
            transition="scale-transition"
            offset-y
            z-index="11"
            v-bind="props.datePickerMenu"
          >
            <template #activator="{ on, attrs }">
              <div v-on="!disabled && on">
                <v-text-field
                  :value="value.deadline"
                  persistent-hint
                  v-bind="{
                    ...(!disabled && attrs),
                    ...props.validatedField,
                  }"
                  :rules="[rules.required]"
                  :disabled="disabled"
                  :class="{ 'input-calendar': !disabled }"
                  readonly
                  placeholder="Wybierz datę"
                  append-icon="mdi-calendar-month-outline"
                  @input="update('deadline', $event)"
                />
              </div>
            </template>
            <v-date-picker
              v-model="value.deadline"
              :allowed-dates="allowedDates"
              v-bind="props.datePicker"
            />
          </v-menu>
        </v-col>
      </v-row>
      <v-row
        v-if="!disabled && discLocationVisible"
        class="mt-n10"
      >
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <label class="input-label">Lokalizacja</label>
          <v-text-field
            :value="value.discLocation"
            v-bind="props.validatedField"
            :disabled="disabled"
            placeholder="Podaj nazwę"
            @input="update('discLocation', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="3"
          class="pt-0 d-flex align-center mt-n5"
        >
          <v-checkbox
            dense
            hide-details
            class="mt-0"
            :input-value="value.printCoordination"
            @change="update('printCoordination', $event)"
          /><label class="text--body-2">Do druku</label>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';
import utils from '@/helpers/utils';
import AppStatus from '@/components/UI/AppStatus.vue';

export default {
  components: {
    AppStatus,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      props,
      rules,
      isDatePickerShown: false,
    };
  },

  computed: {
    ...mapState('filters', ['filtersOptions']),

    ...mapGetters('auth', ['checkUserPermissions']),

    discLocationVisible() {
      const availability = ['admin_director', 'chief', 'graphic', 'commercial_print_graphic'];
      return this.checkUserPermissions(availability);
    },
  },

  methods: {
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value });
    },
    allowedDates(val) {
      return utils.allowedDates(val, this.value.createdAt);
    },
  },
};
</script>
